// extracted by mini-css-extract-plugin
export default {"title":"TvSeriesDetail_title__y15dw","font_manager":"TvSeriesDetail_font_manager__Be3Yw","poster":"TvSeriesDetail_poster__x2IRa"};